import {createAsyncThunk} from '@reduxjs/toolkit';
import {AxiosResponse} from 'axios';

import {CUSTOM_LINK_SLICE} from 'features/provide-custom-link/model/constants';
import {TLinkDto} from 'shared/types/links';

import {getCustomLinkConfig} from './api';

interface ILoadCustomLinkConfigArgs {
    key: string;
    url: string;
}

export const loadCustomLinkConfig = createAsyncThunk<AxiosResponse<TLinkDto>, ILoadCustomLinkConfigArgs>(
    `${CUSTOM_LINK_SLICE}/loadCustomLinkConfig`,
    async (args, {rejectWithValue}) => {
        try {
            const {url} = args;
            return await getCustomLinkConfig(url);
        } catch (e) {
            return rejectWithValue(e);
        }
    },
);
